class MobileDock extends HTMLElement {
    constructor() {
      super();
    }
  
    connectedCallback() {
      const header = document.querySelector('.shopify-section-header');
  
      this.isAction = false;
      this.scrollY  = header ? parseInt(header.getBoundingClientRect().bottom) : 0;
  
      if (Shopify && Shopify.designMode) {
        this.scrollY = 0;
      }
  
      this.querySelectorAll('.dock__item[data-action]').forEach((button) => {
        button.addEventListener('click', this.onButtonClick.bind(this));
      });
      document.addEventListener('menudrawer:close', this.hideStickyHeader.bind(this));
      document.addEventListener('searchmodal:close', this.hideStickyHeader.bind(this));
  
      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.onScrollHandler();
  
      document.documentElement.style.setProperty('--mobile-dock-height', `${this.offsetHeight}px`);
      document.addEventListener('matchSmall', () => {
        document.documentElement.style.setProperty('--mobile-dock-height', `${this.offsetHeight}px`);
      });
    }
  
    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }
  
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  
      if (scrollTop >= this.scrollY) {
        this.classList.add('is-active');
      }
      else {
        this.classList.add('is-active');
      }
    }
  
    onButtonClick(event) {
      event.preventDefault();
      const target = event.currentTarget;
      const delay = this.waitStickyHeader();
  
      switch (target.dataset.action) {
        case 'cart':
          this.isAction = true;
  
          const miniCart = document.querySelector('mini-cart');
          if (miniCart) {
            setTimeout(() => {
              miniCart.open();
              document.activeElement.blur();
            }, delay);
          }
          else {
            window.location.href = theme.routes.cart_url;
          }
          break;
  
        case 'menu':
          this.isAction = true;
  
          const headerDrawer = document.querySelector('header-drawer');
          if (headerDrawer) {
            setTimeout(() => {
              headerDrawer.openMenuDrawer();
            }, delay);
          }
          break;
  
        case 'search':
          this.isAction = true;
          
          const searchModals = document.querySelectorAll('search-modal');
          if (searchModals.length > 0) {
            searchModals.forEach((searchModal) => {
              const style = window.getComputedStyle(searchModal);
              if (style.display === 'none') {
                return;
              }
    
              setTimeout(() => {
                searchModal.open();
                searchModal.querySelector('input:not([type="hidden"])').focus();
              }, delay);
            });
          }
          else {
            window.location.href = theme.routes.search_url;
          }
          break;
      }
    }
  
    hideStickyHeader() {
      const header = document.querySelector('sticky-header');
      if (header === null) return;
  
      if (theme.config.mqlSmall && this.isAction && header.sticky()) {
        setTimeout(() => {
          header.hide();
          this.isAction = false;
        }, 500);
      }
    }
  
    waitStickyHeader() {
      const header = document.querySelector('sticky-header');
      if (header === null) return;
  
      if (!header.sticky() && !this.isElementVisible(header)) {
        header.hide();
        setTimeout(() => header.reveal());
  
        return 250;
      }
  
      return 0;
    }
  
    isElementVisible(element) {
      const rect = element.getBoundingClientRect(),
          width  = window.innerWidth || document.documentElement.clientWidth,
          height = window.innerHeight || document.documentElement.clientHeight,
          efp    = function (x, y) { return document.elementFromPoint(x, y) };
  
      // Return false if it's not in the viewport
      if (rect.right < 0 || rect.bottom < 0 || rect.left > width || rect.top > height) {
        return false;
      }
  
      // Return true if any of its four corners are visible
      return (
        element.contains(efp(rect.left,  rect.top))
        || element.contains(efp(rect.right, rect.top))
        || element.contains(efp(rect.right, rect.bottom))
        || element.contains(efp(rect.left,  rect.bottom))
        || element.parentNode.contains(efp(rect.left,  rect.top))
        || element.parentNode.contains(efp(rect.right, rect.top))
        || element.parentNode.contains(efp(rect.right, rect.bottom))
        || element.parentNode.contains(efp(rect.left,  rect.bottom))
      );
    }
  }
  customElements.define('mobile-dock', MobileDock);
  
  /*Custom Code added by Zeus Start*/
  // Function to apply CSS based on visibility
  /*function applyCSSBasedOnVisibility() {
    var elementToWatch = document.querySelector("animate-sticky[animate]");
    var elementToStyle = document.querySelector("iframe#chat-button");
    var elementToStyle2 = document.querySelector(".smile-launcher-frame-container");
    var elementToStyle3 = document.querySelector("iframe#chat-window");
  
    if (elementToWatch && elementToStyle && elementToStyle2) {
      var rect = elementToWatch.getBoundingClientRect();
  
      if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
        // Element is fully visible within the viewport
        elementToStyle.style.transition = "bottom 0.3s ease";
        elementToStyle2.style.transition = "bottom 0.3s ease";
        elementToStyle.style.bottom = "20px";
        elementToStyle2.style.bottom = "20px";
        if (elementToStyle3){
        elementToStyle3.style.bottom = "90px";
          }
      } else {
        // Element is not fully visible or not in the DOM
        elementToStyle.style.transition = "bottom 0.3s ease";
        elementToStyle2.style.transition = "bottom 0.3s ease";
        elementToStyle.style.bottom = "80px";
        elementToStyle2.style.bottom = "80px";
        if (elementToStyle3){
        elementToStyle3.style.bottom = "150px";
        }
      }
    }
  }
  applyCSSBasedOnVisibility();
  window.addEventListener("scroll", applyCSSBasedOnVisibility);*/
  
  function applyCSSBasedOnVisibility() {
    var elementToWatch = document.querySelector(".sticky-cart-wrapper[animate]");
    var elementToStyle = document.querySelector("a#BackToTop");
    var elementToStyle2 = document.querySelector(".transition-body");
  
    if (elementToWatch && elementToStyle2) {
      var rect = elementToWatch.getBoundingClientRect();
  
      if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
        // Element is fully visible within the viewport
         elementToStyle2.style.paddingBottom = "0rem";
        if (elementToStyle) {
          elementToStyle.classList.remove("extra");
  
        }
      } else {
        // Element is not fully visible or not in the DOM
        elementToStyle2.style.paddingBottom = "6rem";
        if (elementToStyle) {
          elementToStyle.classList.add("extra");
        }
      }
    }
  }
  applyCSSBasedOnVisibility();
  window.addEventListener("scroll", applyCSSBasedOnVisibility);
  // Function to apply CSS based on visibility
  
  // Function to show Smile widget after Tolstoy was opened
  document.addEventListener('DOMContentLoaded', function() {
    document.body.addEventListener('click', function(event) {
      const target = event.target.closest('a[href="#smile-home"], a[href="#smile-points-activity-rules"], a[href="#smile-referral-program-details"], a[href="#smile-points-products"]');
      
      if (target) {
        const container = document.getElementById('smile-ui-container');
        container.style.display = 'block';
      }
    });
  });
  // Function to show Smile widget after Tolstoy was opened
  
  // Function to toggle Concerns Start
  document.addEventListener('DOMContentLoaded', function() {
      // Function to handle the toggle action for a button
      function handleButtonClick(button) {
          var hiddenItems = document.querySelectorAll('.hidden-concern');
          var label = button.querySelector('.label');
  
          if (label.textContent === 'View All' || label.textContent === 'عرض الكل') {
              hiddenItems.forEach(function(item) {
                  item.classList.add('show');
                  item.classList.remove('hidden-concern');
              });
              label.textContent = label.textContent === 'View All' ? 'Hide' : 'إخفاء';
          } else if (label.textContent === 'Hide' || label.textContent === 'إخفاء') {
              var allItems = document.querySelectorAll('.concerns-search-item');
              allItems.forEach(function(item) {
                  if (item.classList.contains('show')) {
                      item.classList.remove('show');
                      item.classList.add('hidden-concern');
                  }
              });
              label.textContent = label.textContent === 'Hide' ? 'View All' : 'عرض الكل';
          }
      }
  
      // Handle the first button
      var button1 = document.querySelector('#shopify-section-template--17761361461500__rich_text_EpCxzP a.button.button--cta.button--small');
      if (button1) {
          button1.addEventListener('click', function(event) {
              event.preventDefault();
              handleButtonClick(button1);
          });
      }
  
      // Handle the second button
      var button2 = document.querySelector('#shopify-section-template--18139731525884__rich_text_ULaKwV a.button.button--cta.button--small');
      if (button2) {
          button2.addEventListener('click', function(event) {
              event.preventDefault();
              handleButtonClick(button2);
          });
      }
  });
  // Function to toggle Concerns End
  /*Custom Code added by Zeus End*/